module.exports = __webpack_public_path__ + "static/media/kbank-logo.a03cf5e3.png";